export default __webpack_public_path__ + "static/media/AtkinsonHyperlegibleMono-SemiBold.c0b73a21.woff2";